import Button from '../base/Button';

export default function HeroSection() {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="inicio" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background with gradients and patterns */}
      <div className="absolute inset-0 bg-gradient-to-br from-slate-900 via-blue-900 to-purple-900"></div>
      
      {/* Geometric patterns */}
      <div className="absolute inset-0 opacity-30">
        <div className="absolute top-20 left-20 w-32 h-32 bg-blue-500/20 rounded-full blur-xl"></div>
        <div className="absolute top-40 right-32 w-24 h-24 bg-purple-500/20 rounded-full blur-lg"></div>
        <div className="absolute bottom-32 left-1/4 w-40 h-40 bg-cyan-500/20 rounded-full blur-2xl"></div>
        <div className="absolute bottom-20 right-20 w-28 h-28 bg-blue-400/20 rounded-full blur-xl"></div>
      </div>

      {/* Floating geometric shapes */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-1/4 left-10 w-4 h-4 bg-blue-400 rotate-45 float-animation opacity-60"></div>
        <div className="absolute top-1/3 right-1/4 w-6 h-6 bg-purple-400 rotate-12 float-animation opacity-40" style={{animationDelay: '1s'}}></div>
        <div className="absolute bottom-1/3 left-1/3 w-3 h-3 bg-cyan-400 rotate-45 float-animation opacity-50" style={{animationDelay: '2s'}}></div>
        <div className="absolute bottom-1/4 right-10 w-5 h-5 bg-blue-300 rotate-12 float-animation opacity-70" style={{animationDelay: '0.5s'}}></div>
      </div>

      {/* Grid pattern overlay */}
      <div className="absolute inset-0 opacity-10">
        <div className="w-full h-full" style={{
          backgroundImage: `
            linear-gradient(rgba(59, 130, 246, 0.1) 1px, transparent 1px),
            linear-gradient(90deg, rgba(59, 130, 246, 0.1) 1px, transparent 1px)
          `,
          backgroundSize: '50px 50px'
        }}></div>
      </div>

      {/* Main content */}
      <div className="relative z-10 container mx-auto px-6 text-center">
        <div className="max-w-5xl mx-auto">
          {/* Main heading */}
          <h1 className="text-5xl md:text-7xl lg:text-8xl font-bold mb-6 slide-in-up text-shadow">
            <span className="text-white">Let's get</span>
            <br />
            <span className="gradient-text-primary">digital</span>
          </h1>

          {/* Subtitle */}
          <p className="text-xl md:text-2xl text-white/80 mb-8 max-w-3xl mx-auto leading-relaxed slide-in-up text-shadow-light" style={{animationDelay: '0.2s'}}>
            Desenvolvemos <strong className="text-blue-300">soluções tecnológicas inovadoras</strong> que transformam ideias em realidade digital. 
            Especialistas em <strong className="text-purple-300">desenvolvimento de software</strong> e <strong className="text-cyan-300">consultoria em TI</strong> para empresas de todos os portes.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-12 slide-in-up" style={{animationDelay: '0.4s'}}>
            <Button 
              variant="primary" 
              size="lg"
              onClick={() => scrollToSection('contato')}
              icon="ri-arrow-right-line"
              className="min-w-[200px]"
            >
              Começar Projeto
            </Button>
            <Button 
              variant="secondary" 
              size="lg"
              onClick={() => scrollToSection('sobre')}
              icon="ri-play-circle-line"
              className="min-w-[200px]"
            >
              Conhecer Mais
            </Button>
          </div>

          {/* Stats */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 max-w-4xl mx-auto slide-in-up" style={{animationDelay: '0.6s'}}>
            <div className="text-center">
              <div className="text-3xl md:text-4xl font-bold text-white mb-2">50+</div>
              <div className="text-blue-300 text-sm md:text-base">Projetos Entregues</div>
            </div>
            <div className="text-center">
              <div className="text-3xl md:text-4xl font-bold text-white mb-2">5+</div>
              <div className="text-purple-300 text-sm md:text-base">Anos de Experiência</div>
            </div>
            <div className="text-center">
              <div className="text-3xl md:text-4xl font-bold text-white mb-2">100%</div>
              <div className="text-cyan-300 text-sm md:text-base">Comprometimento</div>
            </div>
            <div className="text-center">
              <div className="text-3xl md:text-4xl font-bold text-white mb-2">24/7</div>
              <div className="text-blue-300 text-sm md:text-base">Suporte Técnico</div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <button 
          onClick={() => scrollToSection('sobre')}
          className="text-white/60 hover:text-white transition-colors duration-300"
        >
          <i className="ri-arrow-down-line text-2xl"></i>
        </button>
      </div>
    </section>
  );
}
